import { isMiBrowser } from '../browser';

export const getIsXpressIdSupported = () => {
    return !isMiBrowser();
};
